import React from 'react';
import { TileGroup, Tile } from 'components/layout/tiles';
import { ClockIcon, ArrowPathIcon } from '@heroicons/react/24/outline';
import { useWizard, WizardStepLayout } from 'components/layout/wizards';
import { REMINDER_TYPES } from 'constants/reminders';

export default function ReminderTypeStep() {
  const { nextStep, data } = useWizard();

  const handleSelect = (type) => {
    nextStep({ type });
  };

  return (
    <WizardStepLayout
      title="Select Reminder Type"
      description="Choose how you want this reminder to behave."
    >
      <TileGroup>
        <Tile
          title="One-time"
          description="Create a single reminder for a specific date and time."
          icon={ClockIcon}
          selected={data.type === REMINDER_TYPES.ONE_TIME}
          onClick={() => handleSelect(REMINDER_TYPES.ONE_TIME)}
        />
        <Tile
          title="Repeating"
          description="Create a reminder that repeats on a schedule."
          icon={ArrowPathIcon}
          selected={data.type === REMINDER_TYPES.REPEATING}
          onClick={() => handleSelect(REMINDER_TYPES.REPEATING)}
        />
      </TileGroup>
    </WizardStepLayout>
  );
}
